import React from "react";
import LegalPage from "../components/LegalPage";

export default function Privacidade() {
  return (
    <LegalPage title="Política de privacidade">
      <h2>Dados recolhidos</h2>
      <p>
        Podemos recolher nome, telefone, email e informação incluída
        voluntariamente em formulários de contacto, inscrição ou orçamento.
      </p>
      <h2>Finalidade</h2>
      <p>
        Os dados são utilizados para responder a pedidos, prestar serviços,
        gerir inscrições e melhorar o atendimento. Não comercializamos dados
        pessoais.
      </p>
      <h2>Conservação e segurança</h2>
      <p>
        Mantemos os dados apenas pelo período necessário às finalidades
        indicadas e aplicamos medidas adequadas de protecção.
      </p>
      <h2>Direitos do titular</h2>
      <p>
        Pode solicitar esclarecimento, correcção ou eliminação de dados através
        de cenfotep@outlook.com.
      </p>
    </LegalPage>
  );
}
